//
// Helpers
//
function $All(selector, context) {
	var arr = [];
	arr.push.apply(arr, (context || document).querySelectorAll(selector));
	return arr;
}


//
// forEach Polyfill
// https://developer.mozilla.org/en-US/docs/Web/API/NodeList/forEach
//
if (window.NodeList && !NodeList.prototype.forEach) {
	NodeList.prototype.forEach = function (callback, thisArg) {
		thisArg = thisArg || window;
		for (var i = 0; i < this.length; i++) {
			callback.call(thisArg, this[i], i, this);
		}
	};
}


//
// Element.closest() Polyfill
// https://developer.mozilla.org/en-US/docs/Web/API/Element/closest
//
if (!Element.prototype.matches) {
	Element.prototype.matches =
	Element.prototype.msMatchesSelector ||
	Element.prototype.webkitMatchesSelector;
}

if (!Element.prototype.closest) {
	Element.prototype.closest = function(s) {
	var el = this;

	do {
		if (Element.prototype.matches.call(el, s)) return el;
		el = el.parentElement || el.parentNode;
	} while (el !== null && el.nodeType === 1);
	return null;
	};
}



//
// Element.remove() Polyfill
// https://github.com/jserz/js_piece/blob/master/DOM/ChildNode/remove()/remove().md
//
(function (arr) {
	arr.forEach(function (item) {
		if (item.hasOwnProperty('remove')) {
			return;
		}
		Object.defineProperty(item, 'remove', {
			configurable: true,
			enumerable: true,
			writable: true,
			value: function remove() {
			if (this.parentNode !== null)
				this.parentNode.removeChild(this);
			}
		});
	});
})([Element.prototype, CharacterData.prototype, DocumentType.prototype]);



//
// Get CSS Breakpoints Value
//
var breakpoint = {};
breakpoint.refreshValue = function () {
	this.value = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
};
window.addEventListener('resize', function(){
	breakpoint.refreshValue();
});
breakpoint.refreshValue();



//
// IE detection
// returns version of IE or false, if browser is not Internet Explorer
//
function detectIE() {
	var ua = window.navigator.userAgent;

	var msie = ua.indexOf('MSIE ');
	if (msie > 0) {
		// IE 10 or older => return version number
		return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
	}

	var trident = ua.indexOf('Trident/');
	if (trident > 0) {
		// IE 11 => return version number
		var rv = ua.indexOf('rv:');
		return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
	}

	var edge = ua.indexOf('Edge/');
	if (edge > 0) {
		// Edge (IE 12+) => return version number
		return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
	}

	// other browser
	return false;
}

if (detectIE() != false){
	if( detectIE() == 16 ) {
		document.documentElement.classList.add('msie edge-16');
	}
	else if( detectIE() >= 17 ) {
		document.documentElement.classList.add('no-msie edge-17+');
	}
	else {
		document.documentElement.classList.add('msie');
	}
} else{
	document.documentElement.classList.add('no-msie');
}



//
// Remove .no-js class from html element if javascript is enabled
//
document.documentElement.className = document.documentElement.className.replace('no-js','js');



//
// Test for touchevent support and if not supported, attach .no-touch class to the HTML tag.
// https://www.prowebdesign.ro/how-to-deal-with-hover-on-touch-screen-devices/
//
if (!('ontouchstart' in document.documentElement)) {
	document.documentElement.className += ' no-touch';
}


const body = document.body;



//
// Target Group
//
const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const targetGroupHash = urlParams.get('targetgroup');

// Filter all Links against some Keywords
function filterLinks(link) {
	const conditions = ['javascript', 'www.radkultur-bw.de', 'nvbw.de', 'baden-wuerttemberg.de', 'youtube.com'];
	return conditions.some(el => link.href.includes(el)) === false;
}


// Update all Links
function updateAllLinks(targetGroup) {
	const allLinksNodeList = document.querySelectorAll('a[href]');

	const allFilteredLinks = Array.from(allLinksNodeList).filter(filterLinks);
	// console.log(allFilteredLinks.length);

	allFilteredLinks.forEach((link) => {
		const href = link.getAttribute('href');
		href && link.setAttribute('href', href + '?targetgroup=' + targetGroup);
	});
}

targetGroupHash != null && targetGroupHash != '' && updateAllLinks(targetGroupHash);



//
// A11y Dialog
//
const checktargetgroup = body.classList.contains('checktargetgroup') && !body.classList.contains('neos-backend');
const modalA11yDialogElement = document.querySelector('#my-dialog-container');

if (false && checktargetgroup && modalA11yDialogElement != null && !targetGroupHash) {
	const a11yDialog = new A11yDialog(modalA11yDialogElement);
	const buttons = document.querySelectorAll('.js-btn-targetgroup');

	a11yDialog.on('show', () => (body.classList.add('locked')));
	a11yDialog.on('hide', () => (body.classList.remove('locked')));
	a11yDialog.show();

	buttons.forEach(function (button) {
		button.addEventListener('click', (el) => {
			const targetGroup = el.target.dataset.targetgroup;

			// Update URL
			const currentUrl = window.location.protocol + "//" + window.location.host + window.location.pathname;
			const newUrlParams = urlParams != '' ? ('?' + urlParams + '&targetgroup=' + targetGroup) : ('?targetgroup=' + targetGroup);
			let newURL = currentUrl + newUrlParams;
			window.history.pushState({ path: newURL }, '', newURL);

			// Update all Links
			updateAllLinks(targetGroup);

			// Close Dialog
			a11yDialog.hide();
		});
	});


}




//
//
//
const h1 = document.querySelectorAll(".js-template-head__headline");


function calculateHeadlines() {
	h1.forEach(function (el) {
		el.querySelectorAll("br.custom").forEach((br) => {
			br.parentElement.removeChild(br);
		});
		el.querySelectorAll(".first").forEach((first) => {
			first.classList.remove("first");
		});
		const $row1 = el.querySelector(".row1");
		const $row2 = el.querySelector(".row2");

		const checkItems = (el, row) => {
			el.map((item) => {
				let pos;
				let currentVal;
				let lastVal;

				currentVal = item;
				if (currentVal != lastVal) {
					pos = el.indexOf(currentVal);
					if (pos != 0) {
						row[pos].classList.add("first");
						if (!row[pos].previousElementSibling.classList.contains("custom")) {
							const br = document.createElement("br");
							br.classList.add("custom");
							row[pos].parentElement.insertBefore(br, row[pos]);
						}
					}
				}
				lastVal = currentVal;
			});
		};

		const checkRow = (el) => {
			const rowHeight = el.getBoundingClientRect().height;
			const rowItemHeight = el.querySelector("i").getBoundingClientRect().height;
			const rowItems = el.querySelectorAll("i");
			const rowFirstItemHeight = rowItems[0].getBoundingClientRect().top;
			const countRows = rowHeight / rowItemHeight;

			if (countRows > 3) {
				el.classList.add('multiline', 'multiline--3');
			} else if (countRows > 2) {
				el.classList.add('multiline', 'multiline--2');
			} else if (countRows > 1) {
				el.classList.add('multiline');
			}


			let arrayRow = [];
			rowItems.forEach(function (el) {
				arrayRow.push(el.getBoundingClientRect().top);
			});
			let br;
			while ((br = el.querySelector("br.custom"))) {
				el.removeChild(br);
			}
			checkItems(arrayRow, rowItems);
		};

		if ($row1) {
			$row1.classList.remove('multiline', 'multiline--2', 'multiline--3');
			checkRow($row1);
		}

		if ($row2) {
			$row2.classList.remove('multiline', 'multiline--2', 'multiline--3');
			checkRow($row2);
		}
	});
}

calculateHeadlines();

let rTo;
window.addEventListener(
	"resize",
	function () {
		clearTimeout(rTo);
		rTo = setTimeout(calculateHeadlines, 200);
	},
	false
);

